import React from 'react';
export function CtaBanner() {
  return <section className="bg-primary py-12 sm:py-16 md:py-20" data-id="element-51">
      <div className="container mx-auto px-4 max-w-7xl text-center" data-id="element-52">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8 px-4" data-id="element-53">
          Ready to Evaluate Laravel Developers with Confidence?
        </h2>
        <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-5 max-w-lg mx-auto" data-id="element-54">
          <a href="https://certificationforlaravel.testportal.com/test.html?t=Xj7qVzGX8p3c" className="px-6 sm:px-8 py-3 bg-white text-primary rounded-2xl hover:bg-gray-100 transition-colors font-medium text-sm sm:text-base" data-id="element-55">
            Try a Sample Test
          </a>
          <a href="#pricing" className="px-6 sm:px-8 py-3 border-2 border-white text-white rounded-2xl hover:bg-white/10 transition-colors font-medium text-sm sm:text-base" data-id="element-56">
            Buy Recruitment Tests
          </a>
        </div>
      </div>
    </section>;
}